import { useEffect } from 'react';

interface MetadataProps {
  title: string;
  description: string;
  keywords?: string[];
  canonical?: string;
}

export function useMetadata({ title, description, keywords = [], canonical }: MetadataProps) {
  useEffect(() => {
    // Update title
    document.title = `${title} - ProxyScrape Tools`;

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    // Update meta keywords
    if (keywords.length > 0) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute('content', keywords.join(', '));
    }

    // Handle canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', 
      canonical || `https://proxyscrape.com${window.location.pathname}`
    );

    // Cleanup
    return () => {
      document.title = '';
      // Remove meta tags on cleanup
      const metaDesc = document.querySelector('meta[name="description"]');
      const metaKeys = document.querySelector('meta[name="keywords"]');
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (metaDesc) metaDesc.remove();
      if (metaKeys) metaKeys.remove();
      if (canonicalLink) canonicalLink.remove();
    };
  }, [title, description, keywords, canonical]);
}
